<template>
  <div class="material-info-card">
    <div class="card-header">
      <div class="card-title">
        <div v-if="!editingData">
          <span class="title-label">{{ $tc('Code', 1) }} / {{ $tc('Reference', 1) }}:</span>
          <span class="title-reference">{{ materialReference }}</span>
        </div>
        <span v-if="editingData" class="title-label">{{ $t(cardLabel) }}</span>
      </div>
      <custom-button
        v-if="showEditButton"
        :icon="'mdi-pencil'"
        :icon-size="13"
        :height="'20px'"
        :width="'20px'"
        :button-styling="buttonStyling"
        @buttonClick="$emit('toggle-edit')"
      />
    </div>
    <div class="card-info" :style="{ 'overflow-y': editingData ? 'auto' : 'hidden' }">
      <div
        v-for="field in fields"
        class="card-info-item-container"
        :key="field.label"
        :style="[{ width: field.size ? field.size : 100/3+'%', overflow: editingData ? 'visible' : 'hidden'}]"
      >
        <v-icon v-if="!editingData">{{ field.icon }}</v-icon>
        <div class="card-info-item" :style="cardInfoItemStyling">
          <input-field
            v-if="editingData"
            :key="field.varName"
            :input-type="field.inputType"
            :value="field.value"
            :label="field.label"
            :input-disabled="field.disabled"
            :select-options-list="field.options"
            :checkbox-options="field.checkboxOptions"
            :min="field.min"
            :max="field.max"
            :step="field.step"
            :size="'large'"
            :clearable="field.clearable"
            :required="field.required"
            :inputFieldContainerStyling="{ 'padding': '0'}"
            :radioOptions="field.inputType === 'radio' ? field.radioOptions : null"
            @input="updateField($event, field)"
          />
          <span
            v-if="!editingData && field.varName !== 'sm_reference'"
            class="card-info-item-label"
          >
            {{ field.label }}:
          </span>
          <img
            v-if="!editingData && fieldIsBarcodeField(field.label)"
            src="../../assets/barcode.png"
            :alt="field.value"
          >
          <span
            v-if="!editingData && field.varName !== 'sm_reference'"
            class="card-info-item-value"
          >
            {{ field.value }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from '../_Atoms/CustomButton'
import InputField from "@/newComponents/_Atoms/InputField.vue";
import _ from 'lodash';

export default {
  name: "MaterialMainInfo",

  components: {
    CustomButton,
    InputField,
  },

  props: {
    fields: {
      type: Array,
      required: true,
    },

    materialReference: {
      type: String,
      required: true,
    },

    editingData: {
      type: Boolean,
    },

    showEditButton: {
      type: Boolean,
    },

    cardLabel: {
      type: String,
    },
  },

  data() {
    return {
      buttonStyling: {
        'padding': '0px',
        'box-shadow': '0px 2px 2px 0px rgba(0, 0, 0, 0.25)',
        'border-radius': '4px'
      },
    }
  },

  computed: {
    cardInfoItemStyling() {
      return {
        'width': this.editingData ? '100%' : 'auto',
        'margin': !this.editingData ? '10px 12px 10px 0' : ' 6px 9px 6px 0'
      }
    },
  },

  methods: {
    fieldIsBarcodeField(label) {
      return label === this.$i18n.t('Barcode')
    },

    updateField: _.debounce(function(event, field) {
      let parsedValue = event;
      switch (field.inputType) {
        case 'radio':
          parsedValue = event === 'True' ? true : false
          break;
        default:
          break;
      }
      this.$emit('update-material', { varName: field.varName, value: parsedValue});
    }, 500),
  },
}
</script>

<style scoped>
.material-info-card {
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  padding: 17px 21px;
  max-height: calc(30% - 8px);
  overflow-y: scroll;
}

.card-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 5px;
}

.title-label {
  color: var(--app-primary-base);
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 11.5px;
  text-transform: uppercase;
}

.title-reference {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  line-height: 11.5px;
  text-transform: uppercase;
}

.card-info-item-container {
  display: flex;
  flex-direction: row;
  gap: 13px;
}

.card-info-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1px;
}

.card-info-item-value,
.card-info-item-label {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 11.5px;
  white-space: nowrap;
}

.card-info-item-value {
  font-weight: 800;
}

.card-info {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-height: calc(100% - 18px);
}

/* @media only screen and (max-height: 1000px) {
  .card-info{
    overflow-y: auto;
  }
} */


.v-icon {
  line-height: 0;
  color: var(--app-primary-base);
  font-size: 15px;
}

::-webkit-scrollbar {
  width: 4px;
}
</style>


// WEBPACK FOOTER //
// src/newComponents/StockManagement/MaterialMainInfo.vue